const getTelehealthStepPosition = () => {
	const LOCATION_STEP = 0;
	const SPECIALITY_OR_EXAM_STEP = 0;
	const PROFESSIONAL_STEP = 1;
	const DISTRICT_STEP = 2;
	const REVIEW_STEP = 2;
	const UNIT_STEP = 3;

	return {
		LOCATION_STEP,
		DISTRICT_STEP,
		SPECIALITY_OR_EXAM_STEP,
		PROFESSIONAL_STEP,
		REVIEW_STEP,
		UNIT_STEP,
	};
};

export {getTelehealthStepPosition};
